import Cookies from 'js-cookie'
import { setLanguage as i18n_setLanguage } from 'redux-i18n'
import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import { AppContainer } from './AppContainer'
import { APP_STEP, startSession } from '../actions/app'
import { ROUTES } from '../actions/routing'
import { NETOP_PORTAL_URL } from '../api/env'
import { AppModal } from './appModal/AppModal'
import { logger } from '../lib/utils/logger'

export class ApplicationComponent extends React.Component {
  componentWillMount () {
    const { languages, lang, settingsLang } = this.props
    logger(languages, lang, settingsLang)
    if (settingsLang !== lang && languages.indexOf(settingsLang) >= 0) {
      this.props.setLanguage(settingsLang)
    }
  }

  componentDidMount () {
    const { currentRoute } = this.props
    logger(currentRoute)

    const shouldStart = [
      ROUTES.ROUTE_TO_ONDEMAND,
      ROUTES.ROUTE_TO_INSTALLED_AGENT,
      ROUTES.ROUTE_TO_CLASSROOM_AGENT,
    ].indexOf(currentRoute) > -1

    if (shouldStart) {
      this.props.startSessionAction()
    }
  }

  render () {
    if (this.props.currentRoute === ROUTES.ROUTE_TO_HOME) {
      window.location = NETOP_PORTAL_URL
      return null
    }

    return (
      <>
        {this.props.step === APP_STEP.RUNNING && <AppContainer />}
        <AppModal backdropAppClassName={this.props.step === APP_STEP.RUNNING ? '' : 'connecting'}/>
      </>
    )
  }
}

ApplicationComponent.contextTypes = {
  t: PropTypes.func.isRequired
}

ApplicationComponent.propTypes = {
  languages: PropTypes.array,
  step: PropTypes.number,
  currentRoute: PropTypes.string,
  lang: PropTypes.string,
  settingsLang: PropTypes.string,
  startSessionAction: PropTypes.func.isRequired,
  setLanguage: PropTypes.func.isRequired,
}

export function mapStateToProps (state) {
  const { location: { query: { lang: queryLang = null } = {} } = {} } = state
  const cookieLang = (Cookies.get('preferred-language') || null)
  const { i18nState: { lang = 'en' } = {} } = state

  let settingsLang = (queryLang || cookieLang || lang)
  settingsLang = typeof settingsLang === 'string' ? settingsLang.toLowerCase() : 'en'

  return {
    step: state.app.step,
    currentRoute: state.router.current,
    settingsLang,
    lang,
  }
}

export function mapDispatchToProps (dispatch) {
  return {
    startSessionAction: () => {
      dispatch(startSession())
    },
    setLanguage: (lang) => {
      dispatch(i18n_setLanguage(lang))
    },
  }
}

export const Application = connect(
  mapStateToProps,
  mapDispatchToProps
)(ApplicationComponent)
